const style = document.createElement('style');
document.head.appendChild(style);

export const toggleBg = (display: 'block' | 'none') => () => {
    const selector = '.canvas-video.welcome-page__background > video';

    style.innerText = `${selector} { display: ${display}; }`;
};
